export default __webpack_public_path__ + "static/media/chatbot.0ccd5a98.png";